// thumbnail-fix.js
(function(){
  document.addEventListener('DOMContentLoaded', function(){
    // Disabled - was causing mobile gallery freeze
  });
})();